import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AutoLogout from "./autologout";
import axios from "axios";
import Swal from "sweetalert2";

function SetMeeting() {
  // State variables to store meeting details
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [location, setLocation] = useState("");
  const [objectives, setObjectives] = useState("");
  const navigate = useNavigate();

  // Function to handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Send meeting data to the server
    axios
      .post("https://brgytracerappserver.onrender.com/setmeeting", {
        // Corrected URL
        date,
        time,
        location,
        objectives,
      })
      .then((response) => {
        console.log(response.data);
        // Reset form fields after successful submission
        setDate("");
        setTime("");
        setLocation("");
        setObjectives("");
        if (response.data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "You've set a Meeting",
            showConfirmButton: false,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Something went wrong!",
          text: "System error!!",
        });
      });
  };
  const handleclosed = () => {
    navigate("/officerpage");
  };
  return (
    <div className="meeting-parent parent-height">
      <AutoLogout />
      <div className="meeting-holder wrap">
        <div className="meeting-holder-container">
          <h3>Set a Meeting</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Date:</label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Time:</label>
              <input
                type="time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Location:</label>
              <input
                type="text"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                required
              />
            </div>
            <div className="form-group object">
              <label>Objectives:</label>
              <textarea
                value={objectives}
                onChange={(e) => setObjectives(e.target.value)}
                required
              />
            </div>
            <div className="button-holder">
              <button type="submit">Set</button>
              <button className="closebtn" type="button" onClick={handleclosed}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SetMeeting;
